import { SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from "react";
import EditableField from "./editable-field/EditableField.tsx";

interface Props {
  customFieldValue: string | undefined | null;
  originalFieldValue: string;
  readonly?: boolean;
  sx?: SxProps<Theme>;
  updateCustomFieldValue?: (customFieldValue: string | undefined) => void;
  onEditMode?: (isEditing: boolean) => void;
}
const CustomLabel = ({
  customFieldValue,
  originalFieldValue,
  updateCustomFieldValue,
  onEditMode,
  readonly,
  sx,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <EditableField
      customFieldValue={customFieldValue}
      originalFieldValue={originalFieldValue}
      updateCustomFieldValue={updateCustomFieldValue}
      sx={sx}
      onEditMode={onEditMode}
      readonly={readonly}
      label="Label"
      defaultLabel="Default Label"
      resetToDefaultText="Reset to Default Label"
    >
      {children}
    </EditableField>
  );
};

export default CustomLabel;
